import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardNaturvardesbedomningCommandBase } from "./AtgardNaturvardesbedomningCommandBase";

export class CreateAtgardNaturvardesbedomningCommand extends AtgardNaturvardesbedomningCommandBase {
    readonly naturvardesomradeGuid: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateAtgardNaturvardesbedomningCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Naturvardesbedomning";

    constructor(atgardGuid: string, naturvardesomradeGuid: string) {
        super(atgardGuid, CreateAtgardNaturvardesbedomningCommand.$type, CommandType.Insert);
        this.naturvardesomradeGuid = naturvardesomradeGuid;
    }
}
